export const normalizeModulosContratos = (modulos) => {
    const modulosContratosNormalizado = [];
    if (modulos && Array.isArray(modulos) && modulos.length > 0) {
        modulos.forEach((modulo) => {
            if(modulo && modulo.fields) {
                const categoriasContratos = [];
                const { mainTitle, categoriasContrato } = modulo.fields;
                if (categoriasContrato && Array.isArray(categoriasContrato) && categoriasContrato.length > 0) {
                    categoriasContrato.forEach((categoria) => {
                        if (categoria && categoria.fields) {
                            let subCategoriasContratosObject = {};
                            const { titleSubtegory, subCategoriasContratos } = categoria.fields;
                            if (subCategoriasContratos && subCategoriasContratos.fields) {
                                const listadoContratosArray = [];
                                const { title, ListadoContratos } = subCategoriasContratos.fields;
                                if (ListadoContratos && Array.isArray(ListadoContratos) && ListadoContratos.length > 0) {
                                    ListadoContratos.forEach((contrato) => {
                                        if (contrato && contrato.fields) {
                                            const { icono, titlePDF, urlDescarga } = contrato.fields;
                                            listadoContratosArray.push({
                                                icon: icono || '',
                                                title: titlePDF || '',
                                                url: urlDescarga || '',
                                            })
                                        }
                                    })
                                }
                                subCategoriasContratosObject = {
                                    title: title || '',
                                    listadoContratos: listadoContratosArray || [],
                                }
                            }
                            categoriasContratos.push({
                                title: titleSubtegory || '',
                                subCategoriasContratos: subCategoriasContratosObject || {},
                            })
                        }
                    })
                }
                modulosContratosNormalizado.push({
                    title: mainTitle || '',
                    categoriasContratos: categoriasContratos || [],
                })
            }
        })
    }
    return modulosContratosNormalizado;
}